import { siteConfig } from '@/mocks/data';

const icons: Record<number, string> = {
  0: 'ri-database-2-line',
  1: 'ri-folders-line',
  2: 'ri-user-heart-line',
  3: 'ri-thumb-up-line',
};

export default function HomeStats() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-accent-500">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
            为什么选择安心导航？
          </h2>
          <p className="text-sm text-background-200/90 max-w-xl mx-auto">
            我们以安全和合规为核心，为成年用户提供最可靠的资源导航服务
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {siteConfig.brand.stats.map((stat, idx) => (
            <div
              key={stat.label}
              className="bg-background-50/10 backdrop-blur-sm rounded-lg p-5 md:p-6 text-center border border-background-50/10"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-background-50/15 text-background-50 mb-4">
                <i className={`${icons[idx] || 'ri-star-line'} text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-200/80">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}